import { ExceptionsClient } from "../client/ExceptionsClient";
import {UNAUTHORISED_USER} from "../constants/ScrubConstants";


export function invokeScrub({scrubType}, dispatcher) {

    ExceptionsClient.invokeScrub({
            scrubType : scrubType
        }).then(({valid, data}) => {
            if (valid) {
                if(data.success=== true) {
                    dispatcher({
                        type: "SET_STATUS",
                        data: "success"
                    });
                } else if(data.success=== false && data.metaData!== null && data.metaData.messageStringId !==null
                    && data.metaData.messageStringId === UNAUTHORISED_USER){
                    dispatcher({
                        type: "UNAUTHORISED_USER",
                        data: "error"
                    });
                } else {
                    dispatcher({
                        type: "SET_STATUS",
                        data: "warning"
                    });
                }
            } else {
                dispatcher({
                    type: "SET_STATUS",
                    data: "error"
                });
            }
        });

}




// WEBPACK FOOTER //
// ./src/commons/api/ScrubInvokeAPI.js